import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { useGetUnit } from '@/api/units/get-unit'
import { FieldList, FieldRow } from '@/components/layout/field-list'
import { Card } from '@/components/ui/card'
import { ErrorMessage } from '@/components/ui/error-message'
import { Typography } from '@/components/ui/typography'

import {
  GENERAL_EMPTY_VALUE,
  getUnitGeneralFields,
  UnitGeneralField,
} from './unit-general.page.constants'
import * as S from './unit-general.page.styled'

export const UnitGeneralPage = () => {
  const { t } = useTranslation(['units'])
  const { unitId } = useParams<{ unitId: string }>()

  const { data: unit, isError, isLoading } = useGetUnit({ unitId: unitId! })

  const pmsTooltip = t('units:detail.general.pmsTooltip')

  const fields = getUnitGeneralFields({ t, unit })

  const renderFields = (items: UnitGeneralField[]) => (
    <FieldList>
      {items.map(({ key, label, value }) => (
        <FieldRow
          key={key}
          label={label}
          pmsTooltip={pmsTooltip}
          value={value || GENERAL_EMPTY_VALUE}
        />
      ))}
    </FieldList>
  )

  return (
    <S.Sections>
      <Card loading={isLoading}>
        <Typography as="h2" size="heading-small" color="black800">
          {t('units:detail.general.title')}
        </Typography>
        {isError ? (
          <ErrorMessage>{t('units:detail.general.error')}</ErrorMessage>
        ) : (
          renderFields(fields)
        )}
      </Card>
    </S.Sections>
  )
}
